import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1384.15184,1232.85621 L1654.44497,1503.07551 L288.974957,1503.07551 L288.974957,1588.96848 L1654.44497,1588.96848 L1384.15184,1859.27367 L1444.89477,1920 L1818.97496,1546.10789 L1444.89477,1172.21577 L1384.15184,1232.85621 Z M650.966702,85.8929738 L813.864276,85.8929738 L813.864276,629.509605 L650.966702,629.509605 C501.04251,629.509605 379.041163,507.627475 379.041163,357.744236 C379.041163,207.775104 501.04251,85.8929738 650.966702,85.8929738 M650.966702,715.402579 L813.864276,715.402579 L813.864276,1256.18474 L899.780718,1256.18474 L899.780718,85.8929738 L1125.65504,85.8929738 L1125.65504,1256.18474 L1211.57149,1256.18474 L1211.57149,85.8929738 L1377.47614,85.8929738 L1377.47614,0 L650.966702,0 C453.702551,0 293.124721,160.448075 293.124721,357.744236 C293.124721,554.954504 453.702551,715.402579 650.966702,715.402579",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTextDirectionLtrLine = /*#__PURE__*/function (_Component) {
  _inherits(IconTextDirectionLtrLine, _Component);

  var _super = _createSuper(IconTextDirectionLtrLine);

  function IconTextDirectionLtrLine() {
    _classCallCheck(this, IconTextDirectionLtrLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconTextDirectionLtrLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTextDirectionLtr",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTextDirectionLtrLine.displayName = "IconTextDirectionLtrLine";
  return IconTextDirectionLtrLine;
}(Component);

IconTextDirectionLtrLine.glyphName = 'text-direction-ltr';
IconTextDirectionLtrLine.variant = 'Line';
IconTextDirectionLtrLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTextDirectionLtrLine;
export { IconTextDirectionLtrLine };